import { ObjectListRequestType, ObjectListResponseType } from '../ObjectListResponseTypes'
import { addonListResponse } from '@/types/addons/SubscriptionAddonResponse'

interface subscriptionListReponse extends ObjectListResponseType {
  subscriptions: subscriptionResponse[]
}

interface subscriptionResponse {
  subscriptionId: number
  type: string
  desc: string
  status: string
  statusId: number
  isDeliveryContact?: number
  product: {
    [key: string]: any
  }
}

interface simSwapResponse {
  success: boolean
}

interface subscriptionRequestBody extends ObjectListRequestType {}

interface MobileProductResponse {
  mobileId: number
  telephoneNumber: string
  label: string
  simCardNumber: string
  simType: string
  imsiNumber: string
  statusId: number
  status: string
  mobilePuk1: string
  mobilePuk2: string
  activateMms: number
  blockInternational: number
  blockVas: number
  outOfBundleSms: number
  dailyBLockingLimit: number
  firstOutOfBundleLimit: number
  monthlyBlockingLimit: number
  monthlyWarningLimit: number
  secondOutOfBundleLimit: number
  bundle: {
    [key: string]: any
  }
  editable: number
  activationDate: string | null
  terminationDate: string | null
  isDeliveryContact?: number
}

interface InternetProductResponse {
  connectionId: number
  address: SubscriptionResponseAddress
  circuitId: string
  label: string
  lex: string | undefined
  utac: string | undefined
  uni: string | undefined
  userName: string
  passWord: string
  fixedIp: number
  fixedIpAddress: string
  useIpV6: number
  saleId: number
  statusId: number
  status: string
  type: string
}

interface SubscriptionResponseAddress {
  street: string
  streetNumber: string
  streetNumberAlpha: string
  bus: string
  zipCode: number
  city: string
  countryId: number
  country: string
}

export interface SubscriptionStatusCountResponseGroup {
  active: number
  inactive: number
  terminated: number
}

export interface SubscriptionStatusCountsResponse {
  internet: SubscriptionStatusCountResponseGroup
  mobile: SubscriptionStatusCountResponseGroup
}

const isMobileProduct = (product: any): product is MobileProductResponse => {
  if (product === undefined) {
    return false
  }
  return 'telephoneNumber' in product
}
const isInternetProduct = (product: any): product is InternetProductResponse => {
  if (product === undefined) {
    return false
  } else if (product.address && product != undefined) {
    return 'circuitId' in product
  }
  return false
}

const isSubscriptionListResponse = (response: any): response is subscriptionListReponse => {
  if (response === undefined) {
    return false
  }
  if (Array.isArray(response)) {
    return 'subscriptions' in response[0]
  }
  return 'subscriptions' in response
}

const isSubscriptionResponse = (response: any): response is subscriptionResponse => {
  if (response === undefined) {
    return false
  }
  if (Array.isArray(response)) {
    return 'subscriptionId' in response[0] && 'product' in response[0]
  }
  return 'subscriptionId' in response && 'product' in response
}

const isSubscriptionRequestBody = (request: any): request is subscriptionRequestBody => {
  if (request === undefined) {
    return false
  }
  return 'type' in request
}

const isSimManagementResponse = (response: any): response is simSwapResponse => {
  if (response === undefined) {
    return false
  }
  return response === 1
}

const isSimsReservedResponse = (response: any): response is string[] => {
  return Array.isArray(response) && response.every((item) => typeof item === 'string')
}

const isSubscriptionStatusCountsResponse = (response: any): response is SubscriptionStatusCountsResponse => {
  if (response === undefined) {
    return false
  }

  return 'mobile' in response && 'active' in response.mobile
}

const isSubscriptionAddonResponse = (response: any): response is addonListResponse => {
  if (response === undefined) {
    return false
  }
  return true
}

export type { subscriptionResponse, subscriptionRequestBody }
export {
  isSubscriptionListResponse,
  isSubscriptionRequestBody,
  isMobileProduct,
  isInternetProduct,
  isSubscriptionResponse,
  isSimManagementResponse,
  isSubscriptionStatusCountsResponse,
  isSubscriptionAddonResponse,
  isSimsReservedResponse,
}
